import AV from 'leancloud-storage'

var APP_ID = '3BMkofK1dfn6TfaHMQvIJ0yw-gzGzoHsz';
var APP_KEY = 'i3gThwKPGhL34SCzeoKGIgTk';
AV.init({
    appId: APP_ID,
    appKey: APP_KEY
})

export default AV


// WEBPACK FOOTER //
// ./src/lib/leancloud.js